import React, { useEffect, useState } from "react";
import axios from "axios";

const Inquiry = () => {

  const [inquiries, setInquiries] = useState([]);

  const fetchInquiries = async () => {

    try {

      const response = await axios.get("https://api.scannscore.com/inquiry");

      setInquiries(response.data);

    } catch (error) {

      console.error("Error fetching inquiries:", error);

    }

  };

  useEffect(() => {

    fetchInquiries();

  }, []);

  return (

    <div className="container mt-4">

      <h3 className="mb-4 fw-bold">Support Inquiries</h3>

      <div className="table-responsive">

        <table className="table table-bordered table-striped">

          <thead className="table-primary">

            <tr>

              {/* <th className="text-center">ID</th> */}
              <th className="text-center">Name</th>
              <th className="text-center">Email</th>
              <th className="text-center">Message</th>
              <th className="text-center">Date</th>
            </tr>

          </thead>

          <tbody>

            {inquiries.length === 0 ? (

              <tr>
                <td colSpan="5" className="text-center">
                  No inquiries found
                </td>
              </tr>

            ) : (

              inquiries.map((item) => (

                <tr key={item.id}>

                  {/* <td className="text-center">{item.id}</td> */}
                  <td className="text-center">{item.name}</td>
                  <td className="text-center">{item.email}</td>
                  <td className="text-center">{item.message}</td>
                  <td className="text-center">{item.created_at}</td>
                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

  );

};

export default Inquiry;